
import { useLocale } from '@/contexts/LocaleContext';

export const useTranslation = () => {
  const { t } = useLocale();
  
  return { t };
};
